exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popupAlert .vs-popup {\n  width: 40% !important;\n}[dir] .popupAlert .vs-popup {\n  border-color: #FF9F43 !important;\n  border: solid;\n  border-width: thin;\n}\n[dir] .popupAlert .vs-popup--header {\n  border-color: #FF9F43 !important;\n  border: solid;\n  border-width: thin;\n}\n\n/* .popupAlert .vs-popup--title h3 {\n  color: #ffffff\n} */\n", ""]);

// exports
